import { render } from "./S710_PraxisgruppeTeilnehmerAdministration.vue?vue&type=template&id=4a413da8&scoped=true&ts=true"
import script from "./S710_PraxisgruppeTeilnehmerAdministration.vue?vue&type=script&lang=ts"
export * from "./S710_PraxisgruppeTeilnehmerAdministration.vue?vue&type=script&lang=ts"

import "./S710_PraxisgruppeTeilnehmerAdministration.vue?vue&type=style&index=0&id=4a413da8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a413da8"]])

export default __exports__